// ЭКРАН ШАГА 3 — каркас трёх видов (B5-2), ПАНЕЛЬ A (B5-3), ПАНЕЛИ B И C (B5-4).
//
// ИСТОЧНИК — борд `docs/design/wizard-s3/Life Map - s3 Deck v8.html` (канон, sha `33f797d2` по
// `docs/design/WIZARD-CANON.md`), вид `intro()` `:461–474`; спека — `🧩 Шаг 3 — Deck`,
// §9 (вид `intro`) и §5 (копи подвала). Копи сверяется машинно
// (`src/render/__parity__/wizard-s3-copy.test.js`), вид — `wizard-s3-style.test.js`.
//
// ⭐ У ПАНЕЛЕЙ B И C ИСТОЧНИКОВ ДВА, И ЭТО НЕ НЕБРЕЖНОСТЬ. Рисунок покоя — байт `Deck v8`
// (`groupHTML` `:487–492`, поля `:504`, микрофон `:412`). Три СОСТОЯНИЯ — запертый чип, отказ
// возможностей, сорванная попытка — лежат в борде `Life Map - s3 Missing states v3.html`, где
// ратифицированы кадрами `C3`, `C3·t`, `BG1`, `M2`, `M4·v2`, `M4·2f`, `M4·s` (`s518.d1`). Этот
// второй борд КАНОНОМ НЕ ЯВЛЯЕТСЯ — реестр говорит прямо: «состояния приземляются в деку новым
// F», и переиздание деки за CD. То есть сегодня у нас есть правила, которых в `Deck v8` нет
// вовсе; каждое из них сверяется со СВОИМ бордом отдельной таблицей парити, а не прощается.
//
// ЧТО ЗДЕСЬ ЕСТЬ:
//   · ВИД `intro` ЦЕЛИКОМ — восемь строк `s3.intro.*` (шесть в теле, две в футере, см.
//     `deckIntro.js`), список этапов oldest-first с римскими и длительностями;
//   · ВИД `deck`, ПАНЕЛЬ A — семь ползунков с полюсами, метка переноса, лист `?` глоссария,
//     точки панелей со счётом и замком, внутренняя полоса прокрутки карточки;
//   · ПАНЕЛЬ B — четыре группы чипов, запор на потолке (`s516.d2`) с ответом на тап (`C3·t`),
//     свободная строка BG3 с чисткой при снятии чипа (`s516.d1`) и `maxlength` (`s510.d3`),
//     листы `?` по группам;
//   · ПАНЕЛЬ C — три поля T1–T3 с капом ввода (`deckField.js`), кнопка микрофона во всех
//     состояниях и обе строки отказа голоса (`deckVoice.js`, копи `s517.d8`);
//   · ЖИВОЙ ГЕЙТ — пол `FLOOR = 2` реально запирает: закрытая CTA с числом, замок панелей B и C,
//     `nudge()` на отказ (тряска кнопки + возврат на A + вспышка нетронутых рядов);
//   · ВИД `done` ЦЕЛИКОМ (B5-6) — надзаголовок, два лида, стена с тапабельными номерами, тихий
//     блок (взаимоисключение, вариант B), память стены в `revealsPlayed`, микро-строка;
//   · ПОПРАВКА АДРЕСА (B5-6) — `deckRedirect`: панель B/C при закрытом гейте и финал при
//     недобранной последней карточке подменяются на законное место ДО отрисовки;
//   · ФУТЕР — пять надписей CTA деки плюс две финала и четыре back через канал `publishGate`
//     (таблица `deckNav.js`);
//   · МИКРО-СТРОКА КАРТОЧКИ (B5-8) — все три состояния узла `#micro` борда: `{n}/7 layers on this
//     card` с хвостом `two is the floor` при недоборе, `{n}/4 choices made`, `{n}/3 answered ·
//     all three optional` (`deckMicro` в `deckNav.js`). Стоит СОСЕДОМ КАРТОЧКИ внутри `.s3-deck`,
//     как у борда внутри `.deck`; канал `publishGate` не расширялся (`s934.d1`).
//
// ЧЕГО ЗДЕСЬ НЕТ И ПОЧЕМУ:
//   · СПАРК (линия по карточкам), ОТБИВКИ МЕЖДУ КАРТОЧКАМИ, ДЕМО-ПРОСМЁТ ПЕРВОЙ КАРТОЧКИ
//     (`.row.demo` у ползунков и `.chip.fresh` у чипов, борд `:112–116` и `:128`) — ⛔ НИ ОДНОГО
//     ИЗ НИХ НЕТ В СКОУПЕ B5-3/B5-4. Спарк и отбивки — B5-5; демо ничей и назван бездомным в
//     приёмке B5-3, закрыт B5-7;
//   · ЗАПИСЬ ГОЛОСА — блок 5г (`3e519875cbb881528587e457354ed989`). Кнопка микрофона нарисована
//     во всех состояниях и по тапу НЕ ДЕЛАЕТ НИЧЕГО — так сказано в тикете дословно; состояния
//     достижимы дев-пресетом `?voice=…` (`deckVoice.js`). Ни `getUserMedia`, ни транспорта, ни
//     молчаливых повторов здесь нет;
//   · АНИМАЦИЯ ВЪЕЗДА КАРТОЧКИ (`.card.in`, борд `:61–62`) — не портирована ни в деке, ни в
//     финале; отрицательное утверждение стоит в парити с обеих сторон;
//   · ХАЙРЛАЙН `.foot-row` борда (`:156`, `border-top` над рядом CTA) — у футера оболочки границы
//     нет вовсе, хотя хром-контракт §2 её называет. Дыра НЕ ЭТОГО тикета и названа в `s934.d1`
//     («вне решения»): граница принадлежит полосе оболочки, а не шагу.
//
// ⚠️ ЧТО ИЗМЕНИЛОСЬ ПО СРАВНЕНИЮ С B5-2. Там гейт ОБЪЯВЛЯЛСЯ ОТКРЫТЫМ и это была названная
// граница: пол считает тронутые ползунки, а ползунков на пустой рамке нет вовсе, то есть честный
// гейт запер бы человека на карточке I навсегда. Ползунки приехали — граница снята, и строка
// `move {N} more to continue`, написанная в B5-1 и проверенная в B5-2, стала достижимой.

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { parseAddress } from '../address.js';
import { HANDLED, useWizard } from '../WizardProvider.jsx';
import { CUSTOM_SENTINEL, LAYERS, LIVING_FOR_MAX } from '../../contracts.js';
import { GROUP_IDS } from '../toWizardInput.js';
import {
  INTRO_BACK, INTRO_COUNT_LABEL, INTRO_HEAD, INTRO_LEDE, INTRO_SPARKNOTE,
  introBody, introCta, introObserver, introStages,
} from './deckIntro.js';
import {
  PANE_SUBS, VIEW, cardAddress, deckFooter, deckMicro, deckRedirect, deckWhere, paneStat,
} from './deckNav.js';
import { DONE_COPY, doneFoot, hardBody, jumpLabel, softBody } from './deckDone.js';
import {
  A11Y_COPY, CARRY_LABEL, CUSTOM_COPY, FIELDS_NOTE, FIELD_COPY, GROUP_COPY, LAYER_COPY, PANES,
  forStage, optionsOf, pickLine,
} from './deckCopy.js';
import {
  carriedRow, deckBlocks, doneOpen, gateOK, nSliders, paneLocked, rememberWall,
} from './deckGate.js';
import { chipLocked, customOpen, groupCount, hasCustom, toggleChip } from './deckChips.js';
import { DEMO_MS, demoPlayed, demoVars, rememberDemo } from './deckDemo.js';
import { clampField, clampLivingFor, pasteInto } from './deckField.js';
import {
  SHEET_CLOSE, SHEET_PICK, SHEET_POLES, glossOf, groupKicker, sliderKicker,
} from './deckGloss.js';
import {
  SLIDER_MAX, SLIDER_MIN, barOf, drawable, fromPointer, hotPole, keyStep, percentOf, valueText,
} from './deckSlider.js';
import {
  MIC, VOICE_COPY, VOICE_LIVE_COPY, fieldFailed, hasVoicePreset, liveMicState, micState, mmss, readVoicePreset,
} from './deckVoice.js';
import { useVoice } from '../voice/useVoice.js';
import {
  SPARK_BOX, SPARK_HEAD_LEAD, cardFull, sparkHalo, sparkHead, sparkPoints, sparkSegments,
  sparkTicks, tickX, valueY,
} from './deckSpark.js';
import {
  BEAT_BOX, BEAT_EYEBROW, BEAT_OUT, beatAhead, beatCaption, beatFrame,
} from './deckBeat.js';

/** Нетронутый ряд — семь `null` по порядку `LAYERS`. Свежий массив на каждый вызов. */
const emptyRow = () => LAYERS.map(() => null);

/** Ряд карточки из конверта; нет ряда — нетронутый (конверт после шага 2 несёт `sliders: []`). */
function rowAt(rows, i) {
  const row = Array.isArray(rows) && Array.isArray(rows[i]) ? rows[i] : null;
  return row && row.length === LAYERS.length ? row : emptyRow();
}

/** Пустой ряд кнопок — четыре группы адаптера, у каждой пустой выбор (борд `reset()`, `:417`). */
const emptyGroups = () => Object.fromEntries(GROUP_IDS.map((id) => [id, []]));

/** Пустой ряд текста. Три поля, пустые строки — форма, которую держит конверт (`step3RowsOK`). */
const emptyText = () => ({ T1: '', T2: '', T3: '' });

/** Ряд кнопок карточки; кривой или отсутствующий — пустой. */
function groupsAt(rows, i) {
  const row = Array.isArray(rows) ? rows[i] : null;
  if (!row || typeof row !== 'object' || Array.isArray(row)) return emptyGroups();
  return Object.fromEntries(GROUP_IDS.map((id) => [id, Array.isArray(row[id]) ? row[id] : []]));
}

/** Ряд текста карточки; кривой или отсутствующий — пустой. */
function textAt(rows, i) {
  const row = Array.isArray(rows) ? rows[i] : null;
  if (!row || typeof row !== 'object' || Array.isArray(row)) return emptyText();
  return {
    T1: typeof row.T1 === 'string' ? row.T1 : '',
    T2: typeof row.T2 === 'string' ? row.T2 : '',
    T3: typeof row.T3 === 'string' ? row.T3 : '',
  };
}

/** Свободная строка BG3 карточки. Не строка — пустая: `undefined` доехал бы до адаптера. */
const custAt = (rows, i) => (Array.isArray(rows) && typeof rows[i] === 'string' ? rows[i] : '');

/**
 * Глиф микрофона — байт борда (`MIC`, `:412`).
 *
 * ⚠️ У БОРДА СОСТОЯНИЙ ГЛИФ КОРОЧЕ НА ОДНУ ЛИНИЮ (нет подставки `8,21 → 16,21`), и берём мы
 * ДЛИННЫЙ — из `Deck v8`. Причина не «он красивее»: канон деки это `Deck v8`, а борд состояний
 * рисует кадры, где глиф — иллюстрация состояния, а не его определение. Сверяется с байтом
 * канона в парити-тесте.
 */
function MicGlyph() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <line x1="12" y1="18" x2="12" y2="21" />
      <line x1="8" y1="21" x2="16" y2="21" />
    </svg>
  );
}

/** Глиф остановки — байт борда (`STOPI`, `:611`). Подменяет микрофон, пока идёт запись. */
function StopGlyph() {
  return (
    <svg width="11" height="11" viewBox="0 0 12 12" aria-hidden="true">
      <rect x="1" y="1" width="10" height="10" fill="currentColor" />
    </svg>
  );
}

/**
 * СПАРК — линия по карточкам (борд `spark()`, `:442–456`). B5-5.
 *
 * ⚠️ СТОИТ ВО ВСЕХ ТРЁХ ВИДАХ, И ЭТО БАЙТ БОРДА: `head()+spark()` у деки (`:507`) и у финала
 * (`:657`), а на интро — между списком этапов и подписью (`:469`). Линия — шапка ПРОХОДА, а не
 * украшение деки; поэтому и подпись под ней (`s3.intro.sparknote`) стояла с B5-2 без линии.
 *
 * Все четыре правила рисунка живут в `deckSpark.js` и проверены таблицей входов; здесь только
 * разметка.
 */
function Spark({ vals, stages, current }) {
  const head = sparkHead(vals);
  const points = sparkPoints(vals);
  const segments = sparkSegments(points);
  const halo = sparkHalo(vals, current);
  const ticks = sparkTicks(stages.map((s) => s.roman), current, vals.map((r) => cardFull(r)));
  const { W, H, PT, PB } = SPARK_BOX;

  return (
    <div data-testid="s3-spark" className="s3-spark">
      <div className="hd">
        <span>{SPARK_HEAD_LEAD}</span>
        <span>
          <b>{head.done}</b>
          {` / ${head.total} stages`}
          {/* ⛔ ХВОСТ УСЛОВНЫЙ И СВОЙ. У капшна отбивки его нет вовсе (`s516.d6`), и строки
              не сводятся, хотя обе начинаются одинаково. */}
          {head.partial > 0 ? <span className="part">{` · ${head.partial} partial`}</span> : null}
        </span>
      </div>

      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true">
        <line className="base" x1="0" y1={valueY(0)} x2={W} y2={valueY(0)} strokeDasharray="2 4" />
        {stages.map((s, i) => (
          <line
            key={s.roman}
            className={`tick${i === current ? ' cur' : ''}`}
            x1={tickX(i, stages.length)}
            y1={PT - 2}
            x2={tickX(i, stages.length)}
            y2={H - PB + 2}
          />
        ))}
        {segments.map((seg) => (
          <path
            key={seg.d}
            className={`seg${seg.gap ? ' gap' : ''}`}
            d={seg.d}
            fill="none"
            strokeWidth="1.6"
            strokeLinecap="round"
            {...(seg.gap ? { strokeDasharray: '3 4' } : {})}
          />
        ))}
        {points.map((p, k) => (p.part
          ? <circle key={p.i} className="dot part" cx={p.x} cy={p.y} r="2.6" fill="none" strokeWidth="1.2" />
          : <circle key={p.i} className={`dot${k === points.length - 1 ? ' last' : ''}`} cx={p.x} cy={p.y} r={k === points.length - 1 ? 3 : 2} />
        ))}
        {halo ? <circle data-testid="s3-spark-halo" className="halo" cx={halo.x} cy={halo.y} r="4.5" fill="none" strokeWidth="1" /> : null}
      </svg>

      <div data-testid="s3-ticks" className="ticks">
        {ticks.map((t, i) => (
          // ключ — индекс намеренно: засечки спарка — фиксированный ряд по этапам, не переставляются
          <span key={i} className={t.state}>{t.label}</span>
        ))}
      </div>
    </div>
  );
}

/**
 * ОТБИВКА МЕЖДУ КАРТОЧКАМИ (борд `beat()`, `:584–610`). B5-5.
 *
 * ⚠️ ТАЙМЕРЫ ПРИХОДЯТ ПАРАМЕТРОМ — требование приёмки. Тест, который ждёт 2200мс по-настоящему,
 * платит две секунды за прогон и становится флаки на загруженной машине.
 *
 * ⚠️ REDUCED MOTION СНИМАЕТ ДВИЖЕНИЕ, А НЕ КАДР. Кадр несёт КОПИ («the line so far · 2/3
 * stages»), и убрать его значило бы отнять текст у того, кто просил не двигать картинку. Гасит
 * анимации CSS-медиазапрос, как у шага 7 (`s7-v4-objects.css:17`), — с видимым конечным
 * состоянием, а не с `display:none`.
 */
function Beat({ frame, roman, name, leaving, holdMs, outMs, onDone }) {
  useEffect(() => {
    const hold = setTimeout(() => onDone('leave'), holdMs ?? frame.hold);
    return () => clearTimeout(hold);
  }, [frame.hold, holdMs, onDone]);

  useEffect(() => {
    if (!leaving) return undefined;
    const gone = setTimeout(() => onDone('gone'), outMs ?? BEAT_OUT);
    return () => clearTimeout(gone);
  }, [leaving, outMs, onDone]);

  const cap = beatCaption(frame);
  const { W, H } = BEAT_BOX;

  return (
    <div data-testid="s3-beat" className={`s3-beat${leaving ? ' out' : ''}`}>
      <div className="eyb">{BEAT_EYEBROW(roman)}</div>
      <div className="nm">{name}</div>

      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true">
        <line className="axis base" x1="0" y1={frame.axis.baselineY} x2={W} y2={frame.axis.baselineY} strokeDasharray="2 4" />
        {frame.axis.ticks.map((x) => (
          <line key={x} className="axis tick" x1={x} y1={BEAT_BOX.PT - 6} x2={x} y2={H - BEAT_BOX.PB + 6} />
        ))}

        {frame.kind === 'first' ? (
          <>
            <circle className="halo" cx={frame.point.x} cy={frame.point.y} r="3" fill="none" strokeWidth="1" />
            <circle className="drop" cx={frame.point.x} cy={frame.point.y} r="4" />
            <text className="ahead" x={Math.min(W - 6, frame.point.x + 14)} y={frame.point.y + 4}>
              {beatAhead(frame.remaining)}
            </text>
          </>
        ) : (
          <>
            {frame.segments.map((seg) => (
              <path
                key={seg.d}
                className={`seg${seg.grow ? ' grow' : ''}${seg.gap ? ' gap' : ''}`}
                pathLength="1"
                d={seg.d}
                fill="none"
                strokeWidth="1.8"
                strokeLinecap="round"
                {...(seg.gap ? { strokeDasharray: '3 4' } : {})}
              />
            ))}
            {frame.points.map((p) => (p.i === frame.prev
              ? <circle key={p.i} className="pop" cx={p.x} cy={p.y} r="4" />
              : <circle key={p.i} className="past" cx={p.x} cy={p.y} r="2" />
            ))}
          </>
        )}
      </svg>

      <div data-testid="s3-beat-cap" className="cap">
        {cap.lead}<b>{cap.bold}</b>{cap.trail}
      </div>
    </div>
  );
}

/** Строка наблюдателя — общая шапка всех трёх видов (борд: `head()` зовётся отовсюду). */
function Observer({ address }) {
  const obs = introObserver(address);
  return (
    <p data-testid="s3-observer" className="s3-obs">
      {obs.lead}{obs.head}{obs.mid}<span className="num">{obs.counter}</span>{obs.trail}
    </p>
  );
}

function Intro({ stages, spark }) {
  const body = introBody(stages.length);
  // ⚠️ КОЛОНКА НА ВСЮ ВЫСОТУ — НЕСУЩАЯ, А НЕ КОСМЕТИКА. `.s3-slist` несёт `flex:1;min-height:0`
  // байтом борда, и без флекс-контекста у РОДИТЕЛЯ эти объявления не делают ничего: список
  // сжимается по содержимому, подпись спарка уезжает ему под ноги, а низ кадра остаётся пустым.
  // Поймано глазом в браузере — парити правил при этом был зелёным, потому что тела правил
  // совпадали с бордом: тест сверяет объявления, а не то, что им есть на чём сработать.
  //
  // ⚠️ ОТСТУПЫ `mt-*` — ИНЛАЙН-СТИЛИ БОРДА (`:463–465`), а не наша композиция. В таблицу пар
  // парити-теста они не попадают по построению (там сверяются ПРАВИЛА), поэтому стоят здесь
  // числами борда и названы: 15px над заголовком, 7px над лидом, 10px над телом.
  return (
    <div data-testid="s3-intro" className="flex min-h-0 flex-1 flex-col">
      <p data-testid="s3-intro-head" className="s3-smcaps mt-[15px]">{INTRO_HEAD}</p>

      {/* ДВЕ СТРОКИ, А НЕ ОДНА С ПЕРЕНОСОМ (§9: «две строки, не одна»). `<br>` борда — это
          композиционное решение, а не перенос по ширине: на узком экране одна строка легла бы
          иначе, и ступень пропала бы. */}
      <p data-testid="s3-intro-lede" className="s3-display-it mt-[7px]">
        {INTRO_LEDE.first}<br />
        {INTRO_LEDE.secondLead}<span className="s3-amb">{INTRO_LEDE.secondAccent}</span>{INTRO_LEDE.secondTrail}
      </p>

      <p data-testid="s3-intro-body" className="s3-subhead mt-[10px]">
        {body.lead}<span className="s3-amb">{body.accent}</span>{body.trail}
      </p>

      <div data-testid="s3-intro-count" className="s3-listhd">
        <span>{INTRO_COUNT_LABEL}</span><b>{stages.length}</b>
      </div>

      <div data-testid="s3-intro-list" className="s3-slist">
        {stages.map((s, i) => (
          <div key={s.roman} data-testid="s3-intro-row" className={`s3-srow${i === 0 ? ' first' : ''}`}>
            <span className="rn">{s.roman}</span>
            <span className="nm">{s.name}</span>
            <span className="dt">{s.duration}</span>
          </div>
        ))}
      </div>

      {/* ⭐ ЛИНИЯ ПРИЕХАЛА (B5-5) — И ОНА СТОИТ МЕЖДУ СПИСКОМ И ПОДПИСЬЮ, как в борде (`:469`).
          С B5-2 здесь висела подпись «the line above draws itself» без линии над ней; граница
          была названа и держалась два тикета. Снята намеренно. */}
      {spark}

      <p data-testid="s3-intro-sparknote" className="s3-micro">
        {INTRO_SPARKNOTE.lead}<b>{INTRO_SPARKNOTE.bold}</b>
      </p>
    </div>
  );
}

/** Порог намерения пальца на дорожке, px: до него жест ничей — тап или начало прокрутки. */
export const TRACK_SLOP = 8;

/** Захват указателя дорожкой; в jsdom метода нет — охрана, а не «иногда не нужен». */
function capture(el, pointerId) {
  if (typeof el.setPointerCapture !== 'function') return;
  try { el.setPointerCapture(pointerId); } catch { /* стенд без указателя */ }
}

/**
 * РЯД ОДНОГО СЛОЯ — подпись, дорожка, три полюса (борд `rowHTML`, `:475–487`).
 *
 * ⚠️ ДОРОЖКА — И ЕСТЬ ПОЛЗУНОК (`role="slider"`), а не обёртка над ним. У борда это `<div>` с
 * `pointerdown` и ничем больше; нативный `<input type=range>` сюда не годится по двум причинам,
 * и обе проверяются: у него свой thumb и своя сетка (делений у нас нет — `s508.d4`), и его вид
 * не собирается из `.base`/`.mid`/`.bar`/`.thumb` байтом борда.
 *
 * ⚠️ `?` — SPAN С `role="button"`, А НЕ `<button>`, И ЭТО ВЫБОР РАДИ ПАРИТИ. Тело правила
 * `.row .help` — канон, а нативной кнопке понадобился бы `background:none` — то есть у нашего
 * правила появилось бы объявление, которого у борда нет, и парити стал бы «почти равно».
 */
function LayerRow({
  layer, index, value, carry, isLast, dragging, demo, rowRef, onPointerDown, onPointerMove,
  onPointerUp, onPointerCancel, onKeyDown, onHelp,
}) {
  const lbId = `s3-lb-${index}`;
  const shown = drawable(value) ? value : null;
  const percent = shown === null ? 50 : percentOf(shown);
  const bar = barOf(percent);
  const hot = hotPole(shown);
  const text = valueText(layer, shown);

  return (
    <div
      ref={rowRef}
      data-testid="s3-row"
      data-layer={layer.key}
      // Значение вне ∓3 из восстановленного конверта НЕ РИСУЕТСЯ (приёмка B5-1, вопрос 3), но
      // тронутость у него настоящая и гейт его считает. Состояние названо атрибутом, чтобы
      // расхождение «считается, но не нарисовано» можно было проверить, а не разглядывать.
      data-out-of-range={value !== null && value !== undefined && !drawable(value) ? 'true' : undefined}
      className={`s3-row${demo ? ' demo' : ''}`}
      // ⚠️ ЧЕТЫРЕ ПЕРЕМЕННЫЕ СТОЯТ ВСЕГДА, А НЕ ТОЛЬКО ПОД ДЕМО — байт борда (`:479`). Развилка
      // «ставить их по флагу» завела бы разметку, которой у борда нет, ради экономии переменных,
      // которые без класса `demo` ничего не красят.
      style={demoVars(index)}
    >
      <div className="q">
        <span id={lbId} className="lb">
          <b>{forStage(layer, 'nameLast', 'name', isLast)}</b>
          {' — '}
          {forStage(layer, 'questionLast', 'question', isLast)}
        </span>
        {carry ? <span data-testid="s3-carry" className="cf">{CARRY_LABEL}</span> : null}
        {/* ⭐ ИМЯ КНОПКИ — КОПИ web-Claude ОТ 26.09 (`A11Y_COPY.layerHelp`). До неё у `?` не было
            доступного имени кроме глифа, и слот стоял открытым: в каноне такой строки нет, а
            сочинять её единолично нельзя. */}
        <span
          data-testid={`s3-help-${index}`}
          className="help"
          role="button"
          aria-label={A11Y_COPY.layerHelp}
          tabIndex={0}
          onClick={onHelp}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onHelp(); }
          }}
        >
          ?
        </span>
      </div>

      <div
        data-testid={`s3-track-${index}`}
        className={`s3-track${dragging ? ' drag' : ''}`}
        role="slider"
        tabIndex={0}
        aria-labelledby={lbId}
        aria-valuemin={SLIDER_MIN}
        aria-valuemax={SLIDER_MAX}
        // ⚠️ `valuenow` У НЕСВЕДЁННОГО НЕТ, А `valuetext` ЕСТЬ, и это не половинчатость. Числа у
        // такой дорожки не существует: поставить `0` значило бы назвать её сведённой в середину —
        // ровно то состояние, которое гейт считает, а эта дорожка нет. Словом же состояние
        // называется честно (`A11Y_COPY.sliderUnset`, копи web-Claude 26.09).
        aria-valuenow={shown === null ? undefined : shown}
        aria-valuetext={text ?? undefined}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
        onKeyDown={onKeyDown}
      >
        <span className="base" />
        <span className="mid" />
        <span className="bar" style={{ left: `${bar.left}%`, width: `${bar.width}%` }} />
        {shown === null ? null : <span data-testid={`s3-thumb-${index}`} className="thumb" style={{ left: `${percent}%` }} />}
        {/* ПРИЗРАКИ ДЕМО — ВНУТРИ ДОРОЖКИ И ПОСЛЕ НАСТОЯЩИХ (борд `:484`). Порядок несёт смысл:
            оба `position:absolute` в одном контексте, и призрак обязан лечь ПОВЕРХ замолчавшего
            ползунка, а не под ним. */}
        {demo ? (
          <>
            <span data-testid={`s3-gbar-${index}`} className="gbar" />
            <span data-testid={`s3-gth-${index}`} className="gth" />
          </>
        ) : null}
      </div>

      <div className="s3-poles">
        <span className={`l${hot === 'l' ? ' hot' : ''}`}>{layer.poles.left}</span>
        <span className={`c${hot === 'c' ? ' hot' : ''}`}>{layer.poles.mid}</span>
        <span className={`r${hot === 'r' ? ' hot' : ''}`}>{layer.poles.right}</span>
      </div>
    </div>
  );
}

/**
 * РАМКА ЛИСТА `?` — вуаль, шит, два уголка и кнопка закрытия (борд `openSheet()`, `:630–636`).
 *
 * ⭐ РАМКА ОБЩАЯ У ДВУХ ЛИСТОВ, И ЭТО БАЙТ БОРДА, А НЕ НАША ЭКОНОМИЯ. У борда `openSheet(html)`
 * принимает тело и одевает его одинаково для слоя и для группы — включая одну и ту же кнопку
 * `got it`. Развести их на два компонента значило бы завести два дома у одного поведения:
 * `Escape`, фокус, задержка ухода.
 *
 * ⭐ ФОКУС УХОДИТ НА КНОПКУ ЗАКРЫТИЯ, А `Escape` ЛИСТ ЗАКРЫВАЕТ — предложение CC, у борда этого
 * нет: он закрывается только тапом. Без первого клавиатурный человек остаётся стоять на `?` под
 * накрытым экраном, без второго — не может выйти вовсе.
 */
function SheetFrame({ onClose, children }) {
  const [shown, setShown] = useState(false);
  const closeRef = useRef(null);

  useEffect(() => {
    const id = requestAnimationFrame(() => setShown(true));
    // `preventScroll` — поймано в браузере: без него фокус на кнопке прокручивает полосу
    // карточки к низу, и список под листом уезжает сам собой. Борд фокус не ставит вовсе.
    if (closeRef.current) closeRef.current.focus({ preventScroll: true });
    return () => cancelAnimationFrame(id);
  }, []);

  // Уход с задержкой — как `kill()` борда: сперва снимается `.on`, через 280мс узлы уходят.
  // Таймер чистится при размонтировании (Н36): открыли заново — родитель поднял новое поколение,
  // этот кадр уходит целиком, и его отложенное закрытие не должно дотянуться до нового листа.
  const timer = useRef(null);
  const leave = useCallback(() => {
    setShown(false);
    clearTimeout(timer.current);
    timer.current = setTimeout(onClose, 280);
  }, [onClose]);
  useEffect(() => () => clearTimeout(timer.current), []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') leave(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [leave]);

  return (
    <>
      <div data-testid="s3-veil" className={`s3-veil${shown ? ' on' : ''}`} onClick={leave} />
      <div data-testid="s3-sheet" className={`s3-sheet${shown ? ' on' : ''}`} role="dialog" aria-modal="true">
        <span className="cor tl" />
        <span className="cor tr" />
        {children}
        <button ref={closeRef} type="button" data-testid="s3-sheet-close" onClick={leave}>
          {SHEET_CLOSE}
        </button>
      </div>
    </>
  );
}

/**
 * ТЕЛО ЛИСТА `?` ПАНЕЛИ A — определение слоя из каталога (борд `sheetLayer()`, `:637–640`).
 *
 * ⛔ ПОДПИСИ `layer glossary · catalog s175–s179` ЗДЕСЬ НЕТ — §19 спеки, слово Кирилла. Её нет и
 * в корпусе (`deckGloss.js`), то есть она не «не печатается», а не портирована вовсе.
 */
function GlossSheetBody({ layer, index, total, isLast }) {
  const gloss = glossOf(layer.key);
  const poles = [layer.poles.left, layer.poles.mid, layer.poles.right];

  return (
    <>
      <span className="s3-smcaps">{sliderKicker(index, total)}</span>
      <h4>{forStage(layer, 'nameLast', 'name', isLast)}</h4>
      {gloss ? (
        <p className="gloss"><b>{gloss.lead}</b>{` ${gloss.body}`}</p>
      ) : null}
      <div className="poles2">
        {SHEET_POLES.map((label, k) => (
          <div key={label}><b>{label}</b><span>{poles[k]}</span></div>
        ))}
      </div>
    </>
  );
}

/**
 * ТЕЛО ЛИСТА `?` ПАНЕЛИ B — подсказка по группе (борд `sheetGroup()`, `:641–643`). B5-4.
 *
 * ⚠️ ЗАГОЛОВОК БЕРЁТ ВОПРОС В ПРОШЕДШЕМ ВРЕМЕНИ ДАЖЕ НА ПОСЛЕДНЕЙ КАРТОЧКЕ, И ЭТО БАЙТ БОРДА:
 * `sheetGroup` печатает `${g.q}` без ветки `qn`, хотя сама панель под ним показывает `qn`. То
 * есть на последней карточке лист и панель говорят в разном времени. Расхождение НАЗВАНО, а не
 * «починено»: эталон — байт, а редакция листа копи-вопрос, и переписывать её единолично нельзя.
 * Утверждение с обеих сторон стоит в парити-тесте.
 *
 * ⚠️ РЯД `pick` — ТА ЖЕ РЕШЁТКА `poles2`, что у листа слоя, но ряд в ней ОДИН. Текст справа
 * собирает `pickLine` из потолка контракта (`s510.d2`), а не из своей копии числа: иначе лист
 * сказал бы «up to 3» там, где валидатор держит два.
 */
function GroupSheetBody({ group, index, total }) {
  return (
    <>
      <span className="s3-smcaps">{groupKicker(index, total)}</span>
      <h4>{group.question}</h4>
      <p>{group.tip}</p>
      <div className="poles2">
        <div><b>{SHEET_PICK}</b><span>{pickLine(group.bg)}</span></div>
      </div>
    </>
  );
}

/**
 * ГРУППА ЧИПОВ ПАНЕЛИ B (борд `groupHTML()`, `:487–492`) плюс кадры `C3`/`C3·t`. B5-4.
 *
 * ⚠️ КРЕСТ ЗАРЕЗЕРВИРОВАН У КАЖДОГО ЧИПА С ПЕРВОЙ ОТРИСОВКИ (`C3`, поправка автора: «the 14px
 * the × needs is now held by EVERY chip from first paint»). Он прозрачен, пока чип не выбран, —
 * и потому ни один ряд не перекладывается в момент, когда группа упирается в потолок. Отсюда
 * класс `rm` на всех чипах, а не только на выбранных.
 *
 * ⚠️ ЗАПЕРТЫЙ ЧИП ВЫГЛЯДИТ КАК ОБЫЧНЫЙ, И ЭТО РЕШЕНИЕ, А НЕ ПРОПУСК ВИДА (`C3`: «locked chips
 * stay in base state, because base state is the truth about them»). Единственное, что меняет
 * потолок, — счётчик в строке подсказки становится амберным.
 *
 * ⛔ `aria-disabled`, А НЕ `disabled` — то же правило, что у закрытой CTA и запертой точки
 * панели: запертый чип ОБЯЗАН ответить на тап (`C3·t`, «obligatory, not optional»), а `disabled`
 * съедает событие. Ответ молчаливый и указывает НА ВЫХОД, а не на себя: кресты выбранных чипов
 * вспыхивают, рамка нажатого опускается на ступень.
 */
function GroupBlock({
  group, index, isLast, picked, cust, flare, dipped, fresh, onChip, onCust, onHelp,
}) {
  const { n, max, atCeiling } = groupCount(picked, group.bg);
  const options = optionsOf(group.bg);
  const custOpen = hasCustom(group.bg) && customOpen(picked);

  const chip = (option, label, extra = '') => {
    const on = picked.includes(option);
    const locked = chipLocked(picked, group.bg, option);
    return (
      <button
        key={option}
        type="button"
        data-testid={`s3-chip-${group.id}`}
        data-option={option}
        data-locked={locked ? 'true' : undefined}
        aria-disabled={locked ? 'true' : undefined}
        aria-pressed={on}
        // ⚠️ `fresh` ВЕШАЕТСЯ НА КАЖДЫЙ ЧИП ВСЕХ ГРУПП, А НЕ ТОЛЬКО НА ВЫБРАННЫЕ (борд `:487`):
        // проявляется панель целиком, и выбранного в демо-момент ещё нет вовсе.
        className={`s3-chip rm${extra}${on ? ' on' : ''}`
          + `${on && flare ? ' flare' : ''}${dipped === option ? ' dip' : ''}`
          + `${fresh ? ' fresh' : ''}`}
        onClick={() => onChip(option)}
      >
        {label}
      </button>
    );
  };

  return (
    <div data-testid="s3-group" data-group={group.id}>
      <div className="s3-gq">
        {forStage(group, 'questionLast', 'question', isLast)}
        {/* ⭐ ИМЯ КНОПКИ — ТА ЖЕ СТРОКА, ЧТО У `?` ПАНЕЛИ A (`A11Y_COPY.layerHelp`, копи
            web-Claude 26.09). Контрол тот же и вопрос тот же; заводить под него вторую строку
            значило бы сочинить копи там, где она уже написана. */}
        <span
          data-testid={`s3-gtip-${index}`}
          className="help"
          role="button"
          aria-label={A11Y_COPY.layerHelp}
          tabIndex={0}
          onClick={onHelp}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onHelp(); }
          }}
        >
          ?
        </span>
      </div>

      {/* СТРОКА ПОДСКАЗКИ есть у трёх групп из четырёх: у группы с одним ответом её в борде нет
          вовсе, и счётчика с ней — тоже. Это согласовано: группа с потолком 1 не запирается
          (`s516.d2`), значит и считать ей нечего. */}
      {group.hint ? (
        <div className="s3-ghint">
          <span>{group.hint}</span>
          <span data-testid={`s3-cnt-${group.id}`} className={`cnt${atCeiling ? '' : ' dim'}`}>
            {n}/{max}
          </span>
        </div>
      ) : null}

      <div className="s3-chips">
        {options.map((o) => chip(o, o))}
        {hasCustom(group.bg) ? chip(CUSTOM_SENTINEL, CUSTOM_COPY.chip, ' cust') : null}
      </div>

      {custOpen ? (
        <div className="s3-custin">
          {/* ⛔ `maxLength` — ДОЛГ `s510.d3`, И ЕГО ДОМ ИМЕННО ЗДЕСЬ. Кап 64 (`LIVING_FOR_MAX`)
              давно режет строку в §II по границе слова, молча: человек узнавал о пределе из
              обрезки в готовом паспорте. Число берётся из контракта, второй копии нет. */}
          <input
            data-testid="s3-custin"
            type="text"
            maxLength={LIVING_FOR_MAX}
            placeholder={CUSTOM_COPY.placeholder}
            aria-label={CUSTOM_COPY.placeholder}
            value={cust}
            onChange={(e) => onCust(e.target.value)}
          />
        </div>
      ) : null}
    </div>
  );
}

/**
 * ПОЛОСА ЗАПИСИ (борд `:618–619`). Точка, таймер, пять столбиков, подпись справа.
 *
 * ⚠️ ТАЙМЕР ИДЁТ ПО-НАСТОЯЩЕМУ, ХОТЯ ЗАПИСИ НЕТ. Это не имитация записи (её нет и не будет до
 * блока 5г) — это индикатор, который обязан быть НАРИСОВАН живым: застывший `0:00` не показал бы
 * ни формата строки, ни того, что полоса вообще двигается. Отсчёт идёт от монтирования полосы.
 */
function RecBar() {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const started = Date.now();
    const id = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 250);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="s3-recbar" className="s3-recbar">
      <span className="dot" />
      <span className="tm">{mmss(seconds)}</span>
      <span className="wv">
        {['0s', '.15s', '.3s', '.45s', '.6s'].map((delay) => (
          <i key={delay} style={{ animationDelay: delay }} />
        ))}
      </span>
      <span className="st">tap to stop</span>
    </div>
  );
}

/**
 * ПОЛЕ ПАНЕЛИ C (борд `:503–504`) плюс кадры `M2` / `M4·v2` / `M4·2f`. B5-4.
 *
 * ⛔ ТАП ПО МИКРОФОНУ НИЧЕГО НЕ ДЕЛАЕТ — так сказано в тикете дословно, и это проверяется
 * тестом, а не оставлено на честное слово. Кнопка при этом настоящая и доступная: у неё есть имя
 * (`title` борда), она фокусируется и отвечает на `Enter`. Не-действие — это состояние тикета, а
 * не сломанный контрол.
 *
 * ⚠️ СТРОКА СОРВАННОЙ ПОПЫТКИ ИДЁТ ПОД РАМКОЙ, А НЕ ВНУТРИ (`M4·v2`: внутри она конкурировала бы
 * с ответом в той же рамке; вариант `M3` с строкой внутри закрыт — слот 28 символов, честного
 * предложения туда не влезает).
 *
 * ⚠️ ПРИ НЕДОСТУПНОМ ГОЛОСЕ СТРОКИ СБОЯ НЕТ: панель уже сказала, что голоса нет вовсе, и
 * сообщать о сорванной попытке было бы сообщением о попытке, которой не было.
 */
function FieldBlock({ field, isLast, value, mic, failed, micOff, line, busyElsewhere, onChange, onPaste, onMicDown, onMicUp, onMicKey }) {
  const recording = mic === MIC.RECORDING;
  const dead = mic === MIC.DEAD || mic === MIC.LIMIT;
  const waiting = mic === MIC.ASKING || mic === MIC.FINISHING;
  const filled = !!value.trim();
  const taRef = useRef(null);
  /** Курсор поля, если оно в фокусе: запись встанет туда, а не в конец (`voiceText.js`). */
  const caret = () => (taRef.current && document.activeElement === taRef.current ? taRef.current.selectionStart : null);

  return (
    <div data-testid="s3-tf" data-field={field.id} className="s3-tf">
      <div className="s3-tfq">
        <span className="ix">{field.id}</span>
        <span>{forStage(field, 'questionLast', 'question', isLast)}</span>
      </div>

      {/* ⚠️ `rec` НА РАМКЕ — БАЙТ БОРДА (`toggleRec`: `box.classList.add('rec')`), и без него
          правило `.s3-tabox.rec` было бы мёртвым CSS: полоса записи есть, а поле под ней
          холодное. Поймано глазом в браузере — парити правил при этом зелёный, потому что
          правило совпадает с бордом; сверять ему было нечего. */}
      <div className={`s3-tabox${filled ? ' filled' : ''}${recording ? ' rec' : ''}${failed ? ' fail' : ''}`}>
        <textarea
          ref={taRef}
          data-testid={`s3-ta-${field.id}`}
          rows={2}
          placeholder={forStage(field, 'placeholderLast', 'placeholder', isLast)}
          aria-label={forStage(field, 'questionLast', 'question', isLast)}
          value={value}
          onChange={(e) => onChange(clampField(e.target.value))}
          onPaste={onPaste}
        />
        {/* ⭐ НАЖАТИЕ — `s908.d3` (Г-4): указатель даёт нажатие/отпускание (тап против удержания),
            клавиатура — переключатель (`click` с `detail === 0`). «3 min» под иконкой — ожидание
            потолка записи заранее. Вид — минимум до редизайна (`s992.d3`). */}
        <span className="s3-miccol">
          <button
            type="button"
            data-testid={`s3-mic-${field.id}`}
            data-mic={mic}
            className={`s3-mic${dead ? ' dead' : ''}${recording ? ' on' : ''}${waiting ? ' wait' : ''}`}
            title="record"
            aria-pressed={recording}
            aria-busy={waiting || undefined}
            disabled={dead || mic === MIC.FINISHING || busyElsewhere}
            onPointerDown={(e) => { if ((e.button ?? 0) === 0) onMicDown?.(caret()); }}
            onPointerUp={() => onMicUp?.()}
            onPointerCancel={() => onMicUp?.()}
            onClick={(e) => { if (e.detail === 0) onMicKey?.(caret()); }}
          >
            {recording ? <StopGlyph /> : <MicGlyph />}
          </button>
          {dead ? null : <span data-testid={`s3-miccap-${field.id}`} className="s3-miccap">{VOICE_LIVE_COPY.cap}</span>}
        </span>
      </div>

      {recording ? <RecBar /> : null}

      {failed ? (
        <div data-testid={`s3-failrow-${field.id}`} className="s3-failrow">
          <span className="dot" />
          <span className="tx">{VOICE_COPY.transportFailed}</span>
        </div>
      ) : null}

      {/* Строка 83 (`s1001.d1`): браузер отказал в доступе без окна — под ЭТИМ полем. Подсказка, а не сбой
          (web-Claude 20.10): голос строки живого голоса без капса, без точки; микрофоны живые, рамку не трогаем. */}
      {micOff ? (
        <div data-testid={`s3-micoff-${field.id}`} className="s3-voiceline hint">{VOICE_COPY.micOff}</div>
      ) : null}

      {line ? (
        <div data-testid={`s3-voiceline-${field.id}`} className="s3-voiceline">{line}</div>
      ) : null}
    </div>
  );
}

/**
 * РЯД КНОПОК-НОМЕРОВ БЛОКА (борд `list()`, `:650`). Общий у стены и у тихого блока.
 *
 * ⛔ ЭТО КНОПКИ, А НЕ ПЕРЕЧИСЛЕНИЕ. Копи стены кончается словами `Tap to go back`, то есть
 * обещание нажимаемости дано текстом; список, по которому нельзя ткнуть, сделал бы копи ложью.
 */
function JumpRow({ indexes, stages, onJump }) {
  return (
    <div className="cards">
      {indexes.map((i) => (
        <button
          key={i}
          type="button"
          data-testid="s3-jump"
          data-jump={i}
          className="gbtn"
          onClick={() => onJump(i)}
        >
          {jumpLabel(i, stages[i])}
        </button>
      ))}
    </div>
  );
}

/**
 * ФИНАЛ ДЕКИ (борд `done()`, `:644–665`). B5-6.
 *
 * ⚠️ ДВА КЛАССА НА КОРНЕ — БАЙТ БОРДА (`<div class="done-wrap card in">`), а не наша экономия:
 * цепочку высот держит `.s3-card`, а центровку и прокрутку добавляет `.s3-done`. Третьего класса
 * (`in`, анимация въезда) у нас нет — он не портирован ни здесь, ни в деке.
 *
 * ⚠️ ВТОРОЙ ЛИД ОДЕТ ИНЛАЙНОМ, КАК В БОРДЕ (`style="color:var(--paper-mute);font-size:12.5px"`).
 * Это ровно тот же случай, что отступы `mt-*` у интро: инлайн-стиль борда в таблицу пар не
 * попадает по построению (там сверяются ПРАВИЛА), поэтому он стоит здесь байтом и назван.
 *
 * ⛔ ДВА БЛОКА ВЗАИМОИСКЛЮЧАЮЩИЕ, И РЕШАЕТ ЭТО НЕ РАЗМЕТКА. Подавлений два и они разные (память
 * стены и одновременность), оба живут в `deckBlocks`; здесь `hard` и `soft` уже посчитаны, и
 * `null` от `hardBody`/`softBody` значит «блока нет», а не «блок пустой».
 */
function Done({ stages, hard, soft, onJump }) {
  const big = DONE_COPY.big(stages.length);
  const wall = hardBody(hard);
  const quiet = softBody(soft);
  const foot = doneFoot();

  return (
    <div data-testid="s3-done" className="s3-card s3-done">
      <div><span className="s3-smcaps">{DONE_COPY.eyebrow}</span></div>

      <div data-testid="s3-done-big" className="big">
        {big.count}<br />
        {big.tail}<span className="s3-amb">{big.accent}</span>{big.end}
      </div>

      <p>{DONE_COPY.lead}</p>
      <p style={{ color: 'var(--paper-mute)', fontSize: '12.5px' }}>{DONE_COPY.leadQuiet}</p>

      {wall ? (
        <div data-testid="s3-wall" className="s3-gaps">
          <div className="gh">{DONE_COPY.hardHeading}</div>
          <p>
            <span className="s3-slot">{wall.lead}<b>{wall.bold}</b>{wall.trail}</span>
          </p>
          <JumpRow indexes={hard} stages={stages} onJump={onJump} />
        </div>
      ) : null}

      {quiet ? (
        <div data-testid="s3-quiet" className="s3-gaps soft">
          <div className="gh">{DONE_COPY.softHeading}</div>
          <p>{quiet.body}</p>
          <JumpRow indexes={soft} stages={stages} onJump={onJump} />
        </div>
      ) : null}

      {/* ⭐ МИКРО-СТРОКА СТОИТ В ТЕЛЕ ШАГА, А НЕ В РЯДУ ПОДВАЛА, И ЭТО РЕШЕНИЕ CC.
          У борда она внутри `.foot-row`, над кнопкой (`.micro{text-align:center;margin-bottom:9px}`
          — то есть отдельная строка НАД CTA, а не рядом с ней). Наш подвал принадлежит оболочке, и
          канала под микро-строку у `publishGate` нет вовсе; заводить четвёртое расширение канала
          ради одной строки дороже, чем поставить её последним узлом тела — визуально это то же
          место, прямо над кнопкой. Носитель тот же `.s3-micro`, которым уже одета подпись спарка
          на интро, и пара у него в таблице стоит с B5-2.
          ⚠️ ВТОРАЯ МИКРО-СТРОКА ШАГА — у ДЕКИ — ЗАКРЫТА B5-8 ТОЙ ЖЕ ФОРМОЙ, но своим узлом:
          `s3-deck-foot` стоит соседом карточки внутри `.s3-deck`. Здесь стояло «она живёт на
          карточке, где тело занято прокруткой, и дома не имеет» — замер это опроверг: у борда
          она не на карточке, а в `.foot-row` рядом с ней (`:512`). */}
      <p data-testid="s3-done-foot" className="s3-micro">
        {foot.lead}<b>{foot.bold}</b>
      </p>
    </div>
  );
}

export default function StepThree() {
  const { session, view, goTo, publishGate, update, shakeCta } = useWizard();

  const rows = session.input.stages;
  const stages = introStages(rows, session.nowY);
  const sliderRows = session.input.sliders;

  // ⭐ АДРЕС РАЗРЕШАЕТСЯ ДО ОТРИСОВКИ, А НЕ ПОСЛЕ (B5-6, пункт 4). Грамматика разбирает `#s3/1/b`
  // и `#s3/{N+1}` всегда; подтверждает ли их СОСТОЯНИЕ — второй вопрос, и отвечает на него
  // `deckRedirect`. Поправка адреса уходит эффектом (в отрисовке истории не трогают), но РИСУЕМ
  // мы уже поправленное положение: иначе между кадром и эффектом человек успел бы увидеть
  // запертую панель, то есть ровно то, от чего адрес и берегут.
  const askedWhere = deckWhere(parseAddress(view), stages.length);
  const askedRow = askedWhere.view === VIEW.DECK ? rowAt(sliderRows, askedWhere.card - 1) : null;
  const redirect = deckRedirect(askedWhere, {
    stageCount: stages.length,
    gateOpen: askedRow ? gateOK(askedRow) : true,
    doneOpen: doneOpen(sliderRows, stages.length),
  });
  const where = redirect ? deckWhere(parseAddress(redirect), stages.length) : askedWhere;

  const isDeck = where.view === VIEW.DECK;
  const cardIndex = isDeck ? where.card - 1 : -1;
  const isLast = isDeck && where.card === stages.length;
  const row = rowAt(sliderRows, cardIndex);
  const carryMask = carriedRow(sliderRows, cardIndex);
  const touched = nSliders(row);
  const groups = groupsAt(session.input.buttons, cardIndex);
  const texts = textAt(session.input.text, cardIndex);
  const cust = custAt(session.input.cust, cardIndex);
  // ⛔ ГЕЙТ СЧИТАЕТСЯ ИЗ СОСТОЯНИЯ ПРИ ОТРИСОВКЕ, А НЕ В ОБРАБОТЧИКЕ — байт борда (`:429`, «Function
  // of state, never of a tap») и контракт `README.md` пака гейта. Отсюда следует то, ради чего это
  // решение и принималось: прямой вход по адресу, возврат назад и resume из снимка проходят ОДНУ
  // проверку, и доказывать это отдельной веткой не нужно — её нет.
  const gateOpen = isDeck ? gateOK(row) : true;
  const paneCurrent = isDeck ? where.pane : 0;
  const gateShut = isDeck && paneCurrent === 0 && !gateOpen;
  const micro = deckMicro(where, session.input, { gateOpen });

  // ⚠️ РЯДЫ ДОСТРАИВАЮТСЯ ПОД ЧИСЛО ЭТАПОВ ИМЕННО ЗДЕСЬ, И БЕЗ ЭТОГО ФИНАЛ СОВРАЛ БЫ. Конверт
  // после шага 2 несёт `sliders: []`; `deckBlocks` на пустом массиве отвечает «под полом никого»,
  // то есть финал ни разу не тронутой деки показал бы открытую CTA вместо стены на все карточки.
  // Считает по КОНВЕРТУ, как `paneStat`, а не по тому, что нарисовано.
  const deckRows = stages.map((_, k) => rowAt(sliderRows, k));
  const blocks = deckBlocks(deckRows, session.revealsPlayed);
  const isDone = where.view === VIEW.DONE;
  // Закрытая CTA финала — это стена, а не пол карточки: два разных отказа, и ответы у них разные
  // (у стены только тряска кнопки, вспыхивать нечему — ползунков на этом виде нет вовсе).
  const doneShut = isDone && blocks.hard.length > 0;

  // ⚠️ ЛИСТ `?` ТЕПЕРЬ ЗНАЕТ, ЧЕЙ ОН. До B5-4 состоянием был индекс слоя, и `null` значил
  // «листа нет»; листов стало два, и хранить один индекс на оба означало бы открывать подсказку
  // группы номером слоя. Форма — `{kind, index}`, где `kind` называет панель.
  const [sheet, setSheet] = useState(null);
  // Поколение листа `?` (Н36): каждое открытие — новое число, см. `SheetFrame` ниже.
  const sheetGen = useRef(0);
  const openSheet = useCallback((spec) => { sheetGen.current += 1; setSheet({ ...spec, gen: sheetGen.current }); }, []);
  const [drag, setDrag] = useState(null);
  const [moreBelow, setMoreBelow] = useState(false);
  const [flashTick, setFlashTick] = useState(0);
  // ОТКАЗ ЗАПЕРТОГО ЧИПА (`C3·t`). Счётчик, а не флаг, — как у вспышки рядов: второй тап подряд
  // обязан ответить второй раз. `dipped` помнит, по какому чипу пришёл тап: рамка опускается у
  // НЕГО, а вспыхивают кресты выбранных — ответ указывает на выход, а не на себя.
  const [refusal, setRefusal] = useState(null);
  // ОТБИВКА (B5-5). `{ card, to, leaving }` — какую карточку закрыли, куда идём и началась ли
  // фаза ухода. Держится состоянием экрана, а не таймером в обработчике: переход обязан
  // пережить перерисовку, а не жить в замыкании одного нажатия.
  const [beat, setBeat] = useState(null);
  // ДЕМО-ПРОСМЁТ (B5-7). `demoOver` — половина «флаг погас по таймеру»; вторая половина, память
  // между заходами, живёт токеном в конверте.
  const [demoOver, setDemoOver] = useState(false);
  const demoLatch = useRef(undefined);
  const dragRef = useRef(null);
  const rowRefs = useRef([]);
  const scrollRef = useRef(null);

  /**
   * ДЕВ-ПРЕСЕТ СОСТОЯНИЙ ГОЛОСА — читается ОДИН РАЗ за монтирование.
   *
   * Перечитывать его на каждый рендер незачем: строка запроса при навигации по деке не меняется
   * (ходим по хешу), а чтение `window` в теле компонента на каждом кадре — лишняя причина для
   * расхождения между отрисовками.
   */
  const voice = useMemo(
    () => readVoicePreset(typeof window === 'undefined' ? '' : window.location.search),
    [],
  );
  /** Пресет задан в адресе — живой голос не включается: пресет B5-4 остаётся отладкой состояний. */
  const presetOn = useMemo(
    () => hasVoicePreset(typeof window === 'undefined' ? '' : window.location.search),
    [],
  );

  /**
   * ЖИВОЙ ГОЛОС (Г-4). Писатель поля берёт АДРЕС явно (карточка + T1–T3), а не текущую карточку
   * экрана: запись, начатая на карточке II, дописывает финал в карточку II, даже если человек
   * уже листнул дальше (`useVoice.js`).
   */
  const sessionRef = useRef(session);
  sessionRef.current = session;
  const readField = useCallback((card, id) => textAt(sessionRef.current.input.text, card)[id], []);
  const writeField = useCallback((card, id, fn) => {
    update((s) => {
      const count = s.input.stages.length;
      if (card < 0 || card >= count) return s;
      const next = Array.from({ length: count }, (_, k) => textAt(s.input.text, k));
      const cur = next[card][id];
      const val = clampField(fn(cur));
      if (val === cur) return s;
      next[card] = { ...next[card], [id]: val };
      return { ...s, input: { ...s.input, text: next } };
    });
  }, [update]);
  const liveVoice = useVoice({ writeField, readField, stages: session.input.stages.length });
  const stopVoice = useRef(liveVoice.stop);
  stopVoice.current = liveVoice.stop;
  // Ушёл с карточки или панели — «стоп и сохранить» (`s908.d3`: отпускание/уход никогда не отмена).
  useEffect(() => () => stopVoice.current(), [cardIndex, paneCurrent]);

  /** Пропсы голоса одного поля: пресет B5-4 (если задан в адресе) или живой контроллер. */
  const voiceProps = (id) => {
    if (presetOn) return { mic: micState(voice, id), failed: fieldFailed(voice, id), line: null, busyElsewhere: false };
    const st = liveVoice.state;
    const here = liveVoice.where?.card === cardIndex && liveVoice.where?.field === id;
    const active = here && st.phase !== 'idle';
    const mic = liveMicState(st, active);
    let line = null;
    if (active && st.phase === 'finishing') line = VOICE_LIVE_COPY.finishing;
    else if (st.limit && here) line = VOICE_LIVE_COPY.limit;
    return {
      mic,
      // Строка сбоя у поля (`s517.d7`, `M4·v2`): микрофон при ней живой, текст на месте; две строки на двух полях.
      failed: liveVoice.failedAt(cardIndex, id),
      // Отказ в доступе без окна (строка 83) — только у поля последней попытки; новая попытка снимает.
      micOff: here && st.micOff === id && st.phase === 'idle',
      line,
      busyElsewhere: st.phase !== 'idle' && !active,
      onMicDown: (caret) => liveVoice.press(cardIndex, id, caret),
      onMicUp: () => liveVoice.release(),
      onMicKey: (caret) => liveVoice.toggle(cardIndex, id, caret),
    };
  };

  /**
   * ДЕМО-ПРОСМЁТ ПЕРВОЙ КАРТОЧКИ (B5-7) — предикат ОДИН на оба узла, как у борда (`:476`/`:487`).
   *
   * ⭐ РЕШЕНИЕ ПРИНИМАЕТСЯ ОДИН РАЗ — ПРИ ПЕРВОМ ПОКАЗЕ КАРТОЧКИ I, и защёлка здесь именно для
   * этого. Читать `demoPlayed` на каждом кадре нельзя: токен пишется эффектом НЕМЕДЛЕННО (иначе
   * уход со шага раньше таймера не запомнился бы), и предикат погасил бы сам себя на следующем
   * же рендере — демо оборвалось бы на первом кадре. Решать в инициализаторе `useState` тоже
   * нельзя: человек мог смонтировать экран на карточке II и прийти на I позже, не перемонтировав
   * компонент, — тогда демо не сыграло бы вовсе.
   */
  if (demoLatch.current === undefined && isDeck && cardIndex === 0) {
    demoLatch.current = !demoPlayed(session.revealsPlayed);
  }
  const demoOn = demoLatch.current === true && !demoOver && isDeck && cardIndex === 0;

  /** Самогашение флага таймером — байт борда (`:517`), 4200 мс после отрисовки первой карточки. */
  useEffect(() => {
    if (!demoOn) return undefined;
    const id = setTimeout(() => setDemoOver(true), DEMO_MS);
    return () => clearTimeout(id);
  }, [demoOn]);

  /**
   * ПАМЯТЬ ДЕМО — токеном в конверте, по образцу памяти стены.
   *
   * ⚠️ ПИШЕТСЯ В МОМЕНТ ПОКАЗА, А НЕ ПО ОКОНЧАНИИ. Иначе «один раз за сессию» держалось бы
   * таймером: ушёл с шага через две секунды, вернулся — и демо начинается заново, хотя человек
   * его уже видел.
   */
  useEffect(() => {
    if (!demoOn) return;
    update((s) => {
      const played = rememberDemo(s.revealsPlayed);
      return played === s.revealsPlayed ? s : { ...s, revealsPlayed: played };
    });
  }, [demoOn, update]);

  /**
   * ВСПЫШКА НЕТРОНУТЫХ РЯДОВ (борд `nudge()`, `:565`) — через DOM и reflow, как тряска CTA в
   * оболочке и как у борда (`void r.offsetWidth`). Ключом узел пересоздавать нельзя: у ряда
   * внутри фокусируемая дорожка, и пересоздание отняло бы фокус у того, кто пришёл с клавиатуры.
   *
   * ⚠️ ПОВОД — СЧЁТЧИК, А НЕ ФЛАГ, и эффект намеренно зависит ТОЛЬКО от него: второй отказ подряд
   * обязан мигнуть второй раз. Возврат на панель A при этом успевает отрисоваться раньше эффекта,
   * поэтому узлы здесь уже те, что на экране.
   */
  useEffect(() => {
    if (!flashTick) return;
    row.forEach((v, li) => {
      if (v !== null && v !== undefined) return;
      const node = rowRefs.current[li];
      if (!node) return;
      node.classList.remove('flash');
      void node.offsetWidth;
      node.classList.add('flash');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flashTick]);

  /** Отказ гейта со стороны ЭКРАНА: вернуть на панель A и мигнуть нетронутыми. */
  const nudgeScreen = useCallback(() => {
    if (isDeck && paneCurrent !== 0) goTo(cardAddress(where.card, 0));
    setFlashTick((t) => t + 1);
  }, [goTo, isDeck, paneCurrent, where.card]);

  /** Полный `nudge()` борда: тряска кнопки подвала плюс экранная половина. */
  const nudge = useCallback(() => {
    shakeCta();
    nudgeScreen();
  }, [shakeCta, nudgeScreen]);

  /**
   * ЕДИНСТВЕННЫЙ ПИСАТЕЛЬ `input.sliders`.
   *
   * ⚠️ ПЕРВОЕ ЖЕ КАСАНИЕ ДОСТРАИВАЕТ РЯДЫ ПОД ВСЕ ЭТАПЫ, и это не запас «на всякий случай»:
   * конверт после шага 2 несёт `sliders: []`, а адаптер (`toWizardInput`) на рассинхроне длин
   * кричит `wizard state is misaligned`. Борд делает то же самое в `reset()` — строит ряды по
   * числу этапов заранее. Нетронутые остаются `null` (легальное значение, `s443.d5`).
   */
  const writeSlider = useCallback((li, value) => {
    update((s) => {
      const count = s.input.stages.length;
      const next = Array.from({ length: count }, (_, k) => rowAt(s.input.sliders, k));
      if (!next[cardIndex]) return s;
      next[cardIndex] = next[cardIndex].map((v, j) => (j === li ? value : v));
      return { ...s, input: { ...s.input, sliders: next } };
    });
  }, [update, cardIndex]);

  /**
   * ЕДИНСТВЕННЫЙ ПИСАТЕЛЬ `input.buttons` И `input.cust` — один на два ряда, и это НЕ удобство.
   *
   * `s516.d1` требует, чтобы снятие чипа `__cust` чистило свободную строку. Если ряды пишут два
   * вызова, между ними существует кадр, где сентинел уже снят, а текст ещё лежит, — и автосейв
   * имеет полное право записать конверт именно в этот момент. Тогда восстановленная сессия
   * приедет ровно в то состояние, которое решение и закрывает. Одна запись — одно состояние.
   *
   * ⚠️ РЯДЫ ДОСТРАИВАЮТСЯ ПОД ВСЕ ЭТАПЫ ПЕРВЫМ ЖЕ ТАПОМ — та же причина, что у ползунков:
   * конверт после шага 2 несёт пустые массивы, а адаптер кричит на рассинхрон длин.
   */
  const writeChip = useCallback((group, option) => {
    update((s) => {
      const count = s.input.stages.length;
      const buttons = Array.from({ length: count }, (_, k) => groupsAt(s.input.buttons, k));
      if (!buttons[cardIndex]) return s;

      // ⛔ РЕШЕНИЕ СЧИТАЕТСЯ ЗДЕСЬ, ИЗ `s`, А НЕ СНАРУЖИ ИЗ ЗАМЫКАНИЯ ОТРИСОВКИ. Поймано ГЛАЗОМ
      // В БРАУЗЕРЕ: три тапа в одном тике брали один и тот же `picked` прошлого рендера, каждый
      // писал свой одиночный выбор поверх предыдущего, и из трёх чипов оставался последний.
      // Тест этого не видел — в нём тапы разделены рендерами. Функциональный апдейт наполовину
      // (свежий `s` снаружи, устаревший аргумент внутри) не функциональный вовсе.
      const res = toggleChip(buttons[cardIndex][group.id], group.bg, option);
      if (res.refused) return s;

      buttons[cardIndex] = { ...buttons[cardIndex], [group.id]: res.picked };
      const custRows = Array.from({ length: count }, (_, k) => custAt(s.input.cust, k));
      if (res.custCleared) custRows[cardIndex] = '';

      return { ...s, input: { ...s.input, buttons, cust: custRows } };
    });
  }, [update, cardIndex]);

  /**
   * Писатель свободной строки BG3.
   *
   * ⚠️ КАП СТОИТ И ЗДЕСЬ, ХОТЯ НА ПОЛЕ ЕСТЬ `maxLength` — поймано в браузере: атрибут держит
   * только руки человека, программная запись значения проходит мимо него (68 символов доехали
   * до конверта при `maxlength="64"`). У этого поля программный писатель уже запланирован —
   * расшифровка голоса блока 5г.
   */
  const writeCust = useCallback((value) => {
    update((s) => {
      const count = s.input.stages.length;
      const custRows = Array.from({ length: count }, (_, k) => custAt(s.input.cust, k));
      if (cardIndex < 0 || cardIndex >= count) return s;
      custRows[cardIndex] = clampLivingFor(value);
      return { ...s, input: { ...s.input, cust: custRows } };
    });
  }, [update, cardIndex]);

  /** Писатель одного поля панели C. Значение приходит УЖЕ обрезанным (`clampField`/`pasteInto`). */
  const writeText = useCallback((id, value) => {
    update((s) => {
      const count = s.input.stages.length;
      const next = Array.from({ length: count }, (_, k) => textAt(s.input.text, k));
      if (!next[cardIndex]) return s;
      next[cardIndex] = { ...next[cardIndex], [id]: value };
      return { ...s, input: { ...s.input, text: next } };
    });
  }, [update, cardIndex]);

  /**
   * ТАП ПО ЧИПУ. Развилка живёт в `deckChips.toggleChip`; здесь — два РАЗНЫХ последствия.
   *
   * ⚠️ ЗАПИСЬ И ОТВЕТ СЧИТАЮТ ЗАПОР В РАЗНЫХ МЕСТАХ, И ЭТО НАМЕРЕННО. Запись — внутри апдейтера,
   * из свежего конверта: ошибиться тут значит записать не то. Ответ — здесь, из состояния
   * отрисовки: это вспышка на 220мс, и на настоящем тапе отрисовка и есть актуальное состояние.
   * Разойдутся они только в случае, которого у человека не бывает (несколько тапов в один тик),
   * и худшее последствие — вспышки не будет; записи при этом всё равно не будет тоже.
   *
   * ⛔ ОТКАЗ НЕ ПИШЕТ КОНВЕРТ ВОВСЕ — апдейтер возвращает тот же `s`. Запись равного значения
   * сдвинула бы ссылку, то есть заставила бы автосейв писать конверт, в котором ничего не
   * изменилось. Ровно та же осторожность, что у `rememberWall`.
   */
  const onChip = useCallback((group, option) => {
    if (chipLocked(groups[group.id], group.bg, option)) {
      setRefusal({ group: group.id, option });
      return;
    }
    writeChip(group, option);
  }, [groups, writeChip]);

  // Ответ запертого чипа живёт ~220мс (`C3·t`), после чего экран возвращается в покой.
  useEffect(() => {
    if (!refusal) return undefined;
    const id = setTimeout(() => setRefusal(null), 220);
    return () => clearTimeout(id);
  }, [refusal]);

  /**
   * ЖЕСТ ПО ДОРОЖКЕ — ТРИ ИСХОДА (тикет `3f319875cbb881e69ee1d0f1361d0b01`, ответ web-Claude s976):
   * тап без сдвига ставит значение; вертикальный жест — прокрутка полосы, значение не трогает;
   * горизонтальный после порога `TRACK_SLOP` — перетаскивание.
   *
   * ⚠️ РАЗВИЛКА ТОЛЬКО ДЛЯ ПАЛЬЦА. Мышь и перо полосу перетаскиванием не прокручивают — у них
   * перетаскивание с первого пикселя, как было. Палец до порога висит в `pending`: точка не едет,
   * конверт не пишется. Вертикаль браузер забирает себе сам (`touch-action: pan-y` на дорожке) и
   * присылает `pointercancel` — отмена НЕ пишет ничего, в отличие от отпускания.
   */
  const trackHandlers = (li) => ({
    onPointerDown: (e) => {
      const el = e.currentTarget;
      const value = fromPointer(e.clientX, el.getBoundingClientRect());
      if (e.pointerType === 'touch') {
        dragRef.current = { li, value, x: e.clientX, y: e.clientY, pending: true };
        return;
      }
      // `setPointerCapture` держит сдвиг за дорожкой, даже если палец ушёл за её края. В jsdom
      // метода нет — отсюда охрана, а не потому, что он «иногда не нужен».
      capture(el, e.pointerId);
      dragRef.current = { li, value };
      setDrag({ li, value });
    },
    onPointerMove: (e) => {
      const d = dragRef.current;
      if (!d || d.li !== li) return;
      if (d.pending) {
        const dx = Math.abs(e.clientX - d.x);
        const dy = Math.abs(e.clientY - d.y);
        if (dy >= TRACK_SLOP && dy >= dx) {
          // Вертикаль — прокрутка. Жест больше не наш, даже если браузер не пришлёт отмену.
          dragRef.current = null;
          return;
        }
        if (dx < TRACK_SLOP || dx <= dy) return;
        capture(e.currentTarget, e.pointerId);
      }
      const value = fromPointer(e.clientX, e.currentTarget.getBoundingClientRect());
      dragRef.current = { li, value };
      setDrag({ li, value });
    },
    // ⛔ КОНВЕРТ ПИШЕТСЯ НА ОТПУСКАНИИ, А НЕ НА КАЖДОМ СДВИГЕ. Борд так же зовёт `paintFoot()`
    // только в `up`. Причина у нас своя и сильнее: каждый сдвиг — это запись конверта, то есть
    // автосейв в хранилище; один жест дал бы сотню записей. Палец, отпущенный до порога, — тап:
    // пишется значение точки касания.
    onPointerUp: () => {
      const d = dragRef.current;
      dragRef.current = null;
      setDrag(null);
      if (d && d.li === li) writeSlider(li, d.value);
    },
    onPointerCancel: () => {
      dragRef.current = null;
      setDrag(null);
    },
    // ⛔ ФОКУС И ПЕРЕХОД ТАБОМ ЗНАЧЕНИЯ НЕ СТАВЯТ: здесь нет ни `onFocus`, ни ветки «первое
    // нажатие любой клавиши». `keyStep` на чужой клавише отвечает `null`, и мы не пишем ничего.
    onKeyDown: (e) => {
      const value = keyStep(e.key, row[li]);
      if (value === null) return;
      e.preventDefault();
      writeSlider(li, value);
    },
  });

  /** Подсказка «ниже есть ещё» — порог 14px, как у борда (`fade()`). */
  const syncFade = useCallback(() => {
    const node = scrollRef.current;
    if (!node) return;
    setMoreBelow(node.scrollHeight - node.clientHeight - node.scrollTop > 14);
  }, []);

  useEffect(() => {
    syncFade();
  }, [syncFade, view, touched]);

  /**
   * ПОПРАВКА АДРЕСА — ОДНИМ ЭФФЕКТОМ НА ОБА СЛУЧАЯ (B5-6, пункт 4).
   *
   * Куда идти, решила чистая функция (`deckRedirect`); здесь только ход, и он ПОДМЕНА ЗАПИСИ:
   * неверный адрес обязан исчезнуть из истории, иначе «назад» браузера возвращал бы на него и
   * поправка срабатывала бы бесконечно.
   */
  useEffect(() => {
    if (redirect) goTo(redirect, { replace: true });
  }, [redirect, goTo]);

  /**
   * ПАМЯТЬ СТЕНЫ (`s903.d2`) — единственное исключение из «гейт есть функция состояния».
   *
   * ⛔ ПИШЕТСЯ НА ПОКАЗ СТЕНЫ, А НЕ НА ЕЁ ПОЧИНКУ, и порядок здесь обратный интуиции: «стена
   * когда-то говорила» из текущих значений не выводится вовсе — к моменту, когда тихий блок
   * имел бы право появиться, недоборы уже починены, и следов от них не осталось. Поэтому токен
   * кладётся ровно тогда, когда стена на экране.
   *
   * ⚠️ РАВНОЕ ЗНАЧЕНИЕ НЕ ПИШЕТСЯ. `rememberWall` возвращает ТОТ ЖЕ массив, если токен уже стоит;
   * вернуть новый конверт на это значило бы сдвинуть ссылку и заставить автосейв писать в
   * хранилище при каждом рендере финала.
   */
  useEffect(() => {
    if (!isDone || !blocks.wall) return;
    update((s) => {
      const played = rememberWall(s.revealsPlayed);
      return played === s.revealsPlayed ? s : { ...s, revealsPlayed: played };
    });
  }, [isDone, blocks.wall, update]);

  /** Прыжок со стены или тихого блока — на панель A названной карточки (борд `data-jump`). */
  const onJump = useCallback((i) => { goTo(cardAddress(i + 1, 0)); }, [goTo]);

  const foot = deckFooter(where, {
    stageCount: stages.length,
    gateOpen,
    touched,
    firstStageName: stages.length ? stages[0].name : '',
    hard: blocks.hard,
  });

  // ⚠️ ПУБЛИКАЦИЯ НА КАЖДЫЙ РЕНДЕР — как у шага 2 и по той же причине: обработчик обязан быть
  // свежим, иначе он уведёт по адресу, с которого человек уже ушёл. Провайдер держит его в `ref`
  // и перерисовывает оболочку только на смену надписи.
  useEffect(() => {
    const isIntro = where.view === VIEW.INTRO;
    publishGate({
      label: isIntro ? introCta(foot.firstStageName) : foot.ctaLabel,
      count: foot.ctaCount ?? null,
      lead: foot.ctaLead ?? null,
      trail: foot.ctaTrail ?? null,
      blocked: gateShut || doneShut,
      backLabel: isIntro ? INTRO_BACK : foot.backLabel,
      // Цель одна на все три вида — её выбрала таблица (`deckNav.js`). Нет цели (финал,
      // пустой конверт) — экран не возражает, и дальше работает обычный ход оболочки.
      onPress: () => {
        // ⭐ ЛИСТ ОТКРЫТ — ПОДВАЛ МОЛЧИТ. У борда экран накрывает `veil` целиком, включая ряд
        // кнопок; у нас подвал живёт ВНЕ полосы шага, и слоем его не накрыть. Гасит его тот же
        // канал, которым экран и говорит с подвалом: `HANDLED` без перехода — это «нажатие
        // принято, идти некуда».
        if (sheet !== null) return HANDLED;
        // ⛔ СТЕНА ФИНАЛА ОТВЕЧАЕТ ОДНОЙ ТРЯСКОЙ, И НУДЖА ЗДЕСЬ НЕТ (борд `#next.onclick`: только
        // `shake`, без `nudge()`). Экранная половина нуджа — возврат на панель A и вспышка
        // нетронутых рядов — на финале не имеет предмета: ни панелей, ни рядов на этом виде нет.
        if (doneShut) return false;
        // Гейт закрыт — отказ, а не переход. Тряску кнопки делает оболочка на `false`, поэтому
        // здесь зовётся только экранная половина — иначе кнопка тряслась бы дважды на один отказ.
        if (gateShut) { nudgeScreen(); return false; }
        if (!foot.ctaTo) return true;
        // ⭐ ОТБИВКА ИГРАЕТ ТОЛЬКО НА УХОДЕ С КАРТОЧКИ, А НЕ НА КАЖДОМ ПЕРЕХОДЕ (борд `onNext`,
        // `:576–580`: `if(S.pane<2){…gotoPane();return}` — смена панели до неё не доходит).
        // Переход откладывается до конца кадра; `HANDLED` говорит оболочке, что нажатие принято.
        if (isDeck && paneCurrent === 2) {
          setBeat({ card: where.card, to: foot.ctaTo, leaving: false });
          return HANDLED;
        }
        goTo(foot.ctaTo);
        return HANDLED;
      },
      // С интро возврат уходит НА ШАГ 2 — единственная кнопка деки, нацеленная туда (§9).
      // Экран не перехватывает, и дальше работает обычный `back` оболочки.
      onBack: () => {
        if (sheet !== null) return false;
        if (!foot.backTo) return true;
        goTo(foot.backTo);
        return false;
      },
    });
  });

  useEffect(() => () => publishGate(null), [publishGate]);

  // ⚠️ `h-full` + `overflow-hidden`, А НЕ `min-h-full`, И ЭТО ПОЙМАНО ГЛАЗОМ В БРАУЗЕРЕ (B5-3).
  // `min-height:100%` задаёт только МИНИМУМ: семь ползунков выше кадра, корень вырастал до 727px
  // при 564px полосы оболочки, и прокручивалась ВСЯ страница — а внутренняя полоса карточки
  // (`.s3-scroll{height:100%}`) не включалась ни разу, хотя все её объявления стояли байтом борда.
  // Это ТОТ ЖЕ КЛАСС, что находка B5-2 про `.s3-slist`: парити правил зелёный, сработать им не на
  // чем. С определённой высотой корня цепочка считается: 564 → карточка → `.s3-body` → полоса 467
  // при содержимом 630. `overflow-hidden` — как `.screen` борда: без него дробная высота карточки
  // давала 1px прокрутки снаружи, то есть волосяную полосу у самого края.
  /**
   * Конец кадра отбивки: сперва фаза ухода, потом переход.
   *
   * ⚠️ ПЕРЕХОД СЛУЧАЕТСЯ В САМОМ КОНЦЕ, А НЕ ПОД УХОДЯЩИМ КАДРОМ. Борд так же: `cb()` зовётся
   * после `b.remove()`. Уведи раньше — и следующая карточка проявится сквозь полупрозрачный
   * уходящий слой, то есть человек увидит её до того, как отбивка договорила.
   */
  const beatDone = useCallback((phase) => {
    if (phase === 'leave') { setBeat((b) => (b ? { ...b, leaving: true } : b)); return; }
    setBeat((b) => {
      if (b) goTo(b.to);
      return null;
    });
  }, [goTo]);

  const sparkNode = stages.length
    ? <Spark vals={sliderRows} stages={stages} current={isDeck ? cardIndex : -1} />
    : null;

  return (
    <div data-testid="step-3" className="s3-screen flex h-full min-h-0 flex-col overflow-hidden">
      <Observer address={view} />
      {where.view === VIEW.INTRO ? <Intro stages={stages} spark={sparkNode} /> : null}
      {/* У деки и финала спарк стоит сразу под строкой наблюдателя (борд `:507`, `:657`);
          у интро он внутри тела, между списком и подписью. */}
      {where.view === VIEW.INTRO ? null : sparkNode}
      {isDeck ? (
        <div data-testid="s3-deck" className="s3-deck">
          <div className="s3-card">
            {(() => {
              const stage = stages[cardIndex] ?? { roman: '', name: '', duration: '' };
              // ⚠️ КОЛОНКА ВНУТРИ ШАПКИ — РАЗМЕТКА БОРДА, а не наша композиция. До B5-3 здесь
              // лежали три спана в ряд, и в браузере имя слипалось с длительностью
              // (`the first year13y 10m`): правила `.cardhd` у нас не было вовсе, то есть спаны
              // стояли строчными. Инлайновый `flex:1;min-width:0` — байт борда (`:635`).
              return (
                <div data-testid="s3-cardhd" className="s3-cardhd">
                  <span className="rn">{stage.roman}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="nm">{stage.name}</div>
                    <div className="dt">{stage.duration}</div>
                  </div>
                </div>
              );
            })()}

            {/* ТОЧКИ ПАНЕЛЕЙ (борд `dotsHTML()`, `:498`). Кнопки, а не украшение: по ним ходят. */}
            <div data-testid="s3-pdots" className="s3-pdots">
              {PANES.map((p, k) => {
                const stat = paneStat(k, session.input, where.card);
                const locked = paneLocked(row, k);
                return (
                  <button
                    key={p.letter}
                    type="button"
                    data-testid={`s3-pdot-${PANE_SUBS[k]}`}
                    data-current={k === paneCurrent ? 'true' : undefined}
                    data-locked={locked ? 'true' : undefined}
                    // `aria-disabled`, а не `disabled`: запертая точка обязана ОТВЕТИТЬ на тап
                    // (тряхнуть кнопку, мигнуть рядами). То же правило, что у закрытой CTA.
                    aria-disabled={locked ? 'true' : undefined}
                    className={`s3-pd${k === paneCurrent ? ' on' : ''}${stat.done ? ' done' : ''}${locked ? ' lock' : ''}`}
                    onClick={() => {
                      if (locked) { nudge(); return; }
                      goTo(cardAddress(where.card, k));
                    }}
                  >
                    <span className="ln" />
                    <span className="tx"><span>{p.letter}</span><b>{stat.count}</b></span>
                  </button>
                );
              })}
            </div>

            <div className="s3-body">
              <div data-testid="s3-scroll" className="s3-scroll" ref={scrollRef} onScroll={syncFade}>
                {/* ШАПКА ПАНЕЛИ (борд `paneHTML()`, `:499–501`) — одна на все три панели. */}
                {(() => {
                  const pane = PANES[paneCurrent];
                  const stat = paneStat(paneCurrent, session.input, where.card);
                  return (
                    <>
                      <div data-testid="s3-panehd" className="s3-sh">
                        <span className="ltr">{pane.letter}</span>
                        <span>{forStage(pane, 'titleLast', 'title', isLast)}</span>
                        <span className="ln" />
                        <span data-testid="s3-panecount" className={`st${stat.done ? ' ok' : ''}`}>
                          {stat.count}
                        </span>
                      </div>
                      <div data-testid="s3-panesub" className="s3-shsub">{pane.sub}</div>
                      {/* ⭐ СТРОКА ОТКАЗА ВОЗМОЖНОСТЕЙ СТОИТ ТАМ, ГДЕ ПОДЗАГОЛОВОК ПАНЕЛИ, И
                          ГОВОРИТСЯ ОДИН РАЗ (кадр `M2`, `s517.d1`). Это состояние ПАНЕЛИ, а не
                          события: причины отказа (нет устройства, небезопасный контекст) не
                          чинятся внутри визарда. Отказ человека сюда не входит (строка 83, `s1001.d1`). Панель B
                          её не печатает — голоса там нет вовсе. */}
                      {paneCurrent === 2 && (presetOn ? !voice.available : liveVoice.state.unavailable) ? (
                        <div data-testid="s3-paneline" className="s3-paneline">
                          {VOICE_COPY.unavailable}
                        </div>
                      ) : null}
                    </>
                  );
                })()}

                {paneCurrent === 0 ? LAYER_COPY.map((layer, li) => (
                  <LayerRow
                    key={layer.key}
                    layer={layer}
                    index={li}
                    value={drag && drag.li === li ? drag.value : row[li]}
                    carry={!!carryMask[li]}
                    isLast={isLast}
                    dragging={!!drag && drag.li === li}
                    demo={demoOn}
                    rowRef={(node) => { rowRefs.current[li] = node; }}
                    onHelp={() => openSheet({ kind: 'layer', index: li })}
                    {...trackHandlers(li)}
                  />
                )) : null}

                {paneCurrent === 1 ? GROUP_COPY.map((group, gi) => (
                  <GroupBlock
                    key={group.id}
                    group={group}
                    index={gi}
                    isLast={isLast}
                    picked={groups[group.id]}
                    cust={cust}
                    flare={!!refusal && refusal.group === group.id}
                    dipped={refusal && refusal.group === group.id ? refusal.option : null}
                    fresh={demoOn}
                    onChip={(option) => onChip(group, option)}
                    onCust={writeCust}
                    onHelp={() => openSheet({ kind: 'group', index: gi })}
                  />
                )) : null}

                {paneCurrent === 2 ? (
                  <>
                    {FIELD_COPY.map((field) => (
                      <FieldBlock
                        key={field.id}
                        field={field}
                        isLast={isLast}
                        value={texts[field.id]}
                        {...voiceProps(field.id)}
                        onChange={(value) => { liveVoice.clearFailed(cardIndex, field.id); writeText(field.id, value); }}
                        // ⛔ ВСТАВКА ПЕРЕХВАЧЕНА, А НЕ ОБРЕЗАНА ПОСТФАКТУМ. Обрежь результат — и
                        // вставка в СЕРЕДИНУ полного поля съела бы хвост, который человек
                        // написал сам (`deckField.js`). Поэтому режется именно ВСТАВКА, в
                        // позицию курсора.
                        onPaste={(e) => {
                          e.preventDefault();
                          const el = e.currentTarget;
                          const insert = e.clipboardData ? e.clipboardData.getData('text') : '';
                          liveVoice.clearFailed(cardIndex, field.id);
                          writeText(
                            field.id,
                            pasteInto(texts[field.id], insert, el.selectionStart, el.selectionEnd),
                          );
                        }}
                      />
                    ))}
                    <div data-testid="s3-optnote" className="s3-optnote">{FIELDS_NOTE}</div>
                  </>
                ) : null}
              </div>
              <div data-testid="s3-fadeh" className={`s3-fadeh${moreBelow ? ' on' : ''}`}>
                {/* Стрелка берёт цвет у родителя (`color:var(--amber)` правилом борда), а не
                    литералом `#D48A3C`: второй дом одного цвета не заводим. */}
                <span>
                  more below
                  {' '}
                  <svg width="11" height="7" viewBox="0 0 13 8" aria-hidden="true">
                    <path d="M1 1l5.5 5.5L12 1" fill="none" stroke="currentColor" strokeWidth="1.6" />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* ⭐ МИКРО-СТРОКА КАРТОЧКИ — СОСЕД КАРТОЧКИ, А НЕ УЗЕЛ ПОДВАЛА ОБОЛОЧКИ (B5-8, `s934.d1`).
              У борда она лежит в `.foot-row` ВНУТРИ `.deck` (`:512`), то есть в контейнере, которым
              экран владеет и так: наш `.s3-deck` — это его `.deck`, а `.s3-card` — его `.card`.
              Прежняя запись «она живёт на карточке, где тело занято прокруткой» была неточна:
              карточка тут ни при чём, и внутренняя полоса этот узел не задевает — он её сосед.
              ⚠️ ЦЕНА НАЗВАНА И ПРИНЯТА (`s934.d1` п. 3): до CTA у нас 9px (`margin-bottom` микро)
              плюс 16px (`pt-4` футера) против 9px у борда. Ряд CTA живёт в чужой полосе, и его
              отступ нам не принадлежит; ту же цену уже платят микро-строки интро и финала.
              ⛔ КАНАЛ НЕ РАСШИРЯЛСЯ: `publishGate` и разметка оболочки этим тикетом не тронуты. */}
          {micro ? (
            <p data-testid="s3-deck-foot" className="s3-micro">
              <b>{micro.bold}</b>{micro.trail}
              {micro.tailSlot
                ? <>{micro.tailLead}<span className="s3-slot">{micro.tailSlot}</span></>
                : null}
            </p>
          ) : null}

          {sheet === null ? null : (
            // ⭐ ПОКОЛЕНИЕ ОТКРЫТИЯ (Н36). Повторное `?` во время ухода — новый лист, а не старый кадр
            // с погашенным `.on`: `key` монтирует его заново, а закрытие гасит только СВОЁ поколение.
            <SheetFrame
              key={sheet.gen}
              onClose={() => setSheet((cur) => (cur && cur.gen === sheet.gen ? null : cur))}
            >
              {sheet.kind === 'layer' ? (
                <GlossSheetBody
                  layer={LAYER_COPY[sheet.index]}
                  index={sheet.index}
                  total={LAYER_COPY.length}
                  isLast={isLast}
                />
              ) : (
                <GroupSheetBody
                  group={GROUP_COPY[sheet.index]}
                  index={sheet.index}
                  total={GROUP_COPY.length}
                />
              )}
            </SheetFrame>
          )}
        </div>
      ) : null}
      {isDone ? (
        <div className="s3-deck">
          <Done stages={stages} hard={blocks.hard} soft={blocks.soft} onJump={onJump} />
        </div>
      ) : null}

      {beat ? (() => {
        const i = beat.card - 1;
        const stage = stages[i] ?? { roman: '', name: '' };
        return (
          <Beat
            frame={beatFrame(sliderRows, i)}
            roman={stage.roman}
            name={stage.name}
            leaving={beat.leaving}
            onDone={beatDone}
          />
        );
      })() : null}
    </div>
  );
}
